module.exports = __webpack_public_path__ + "frontend/img/icon_email.fe9a6a6d.svg";